<style lang="less">
@import "./login.less";
</style>
<template>
  <div class="login" :style="{backgroundImage:`url(${bgImg })`}">
    <!-- <img :src="bgImg" alt> -->
    <div class="login-tit">
       
    </div>
    <div class="login-con">
      <Card icon="log-in" title="欢迎登录" :bordered="false">
        <Tabs v-model="adOrNot" @on-click='goAD'>
            <TabPane label="非AD账号" name="NOAD">
              <div class="form-con">
                <Form ref="loginForm" :model="form" @keydown.enter.native="handleSubmit">
                  <FormItem prop="userName">
                    <Input v-model="form.userName" placeholder="请输入用户名">
                      <span slot="prepend">
                        <img src="../../assets/images/账号.png" alt>
                      </span>
                    </Input>
                  </FormItem>
                  <FormItem prop="password">
                    <Input type="password" v-model="form.password" placeholder="请输入密码">
                      <span slot="prepend">
                        <img src="../../assets/images/密码.png" alt>
                      </span>
                    </Input>
                  </FormItem>
                  <FormItem prop="code" class="form-item-code">
                    <Input v-model="form.checkCode" placeholder="请输入验证码" class="codeinput">
                      <span slot="prepend">
                        <img src="../../assets/images/验证码.png" alt>
                      </span>
                    </Input>
                    <!-- <ImgVerify @imgCode="imgCode" ref="imgVerify"/> -->
                    <img :src="imgUrlNew" alt class="imgVscode" @click="getVscode">
                  </FormItem>
                  <FormItem>
                    <Button @click="handleSubmit" type="primary" long class="loginbtn">登录</Button>
                  </FormItem>
                </Form>
              </div>
            </TabPane>
            <TabPane label="AD账号" name="AD" class="loadCenter">
               <Spin></Spin>
            </TabPane>
        </Tabs>
        
      </Card>
    </div>
  </div>
</template>

<script>
import ImgVerify from "./verifyCode";
import bgImg from '../../assets/images/login-bgNew.png'
// import {
//    getUrlKey
//  } from '../../utils/methods.js'


import * as Msal from "@azure/msal-browser"; // if using CDN, 'Msal' will be available in global scope
let clientId = "085dbedd-ab63-4c82-a110-997d3ccd16c7"//"01b6aa65-5935-4e33-bf94-557a03c3cddb"
const tenantId = "3ce34e42-c07d-47bb-b72a-4ce606de6b88"//"1b3b698e-3e7e-4fc4-99b0-4164fd0ae0b1"
const authority = "https://login.microsoftonline.com/3ce34e42-c07d-47bb-b72a-4ce606de6b88"//"https://login.microsoftonline.com/organizations"//"https://login.partner.microsoftonline.cn/organizations"

export default {
  components: {
    ImgVerify,
  },
  data() {
    
    return {
      adOrNot:'NOAD',//NOAD
      bgImg: bgImg,
      code: "",
      imgUrlNew:'',
      form: {
        userName: "",
        password: "",
        // userName: "18600926804",
        // password: "123456",
        checkCode: ""
      },
      userNameRules: {
        type: "string",
        default: () => {
          return [{ required: true, message: "账号不能为空", trigger: "blur" }];
        }
      },
      passwordRules: {
        type: "string",
        default: () => {
          return [{ required: true, message: "密码不能为空", trigger: "blur" }];
        }
      },
      checkCode: {
        type: "string",
        default: () => {
          return [{ required: true, message: "请输入验证码", trigger: "blur" }];
        }
      }
    };
  },
  methods: {
    // 验证码
    imgCode(code) {
      this.code = code;
    },
    getVscode(){
      let entCode = process.env.NODE_ENV&&process.env.NODE_ENV=='development'?'heinz':'Heinz'
      this.axios
        // .post(this.GLOBAL + `open/${getUrlKey('entCode')}/vercode`,{})
        .post(this.GLOBAL + `open/${entCode}/vercode`,{}) 
        .then(res => {
          // console.log("sss",res.data.data.vercode)
          // this.draw(res.data.data.vercode)
          this.imgUrlNew = 'data:image/jpeg;base64,' + res.data.data.img;
        });
    },
    goAD(){
      let that = this
      const adOrNot = this.adOrNot
      // Configuration object constructed.
      // create PublicClientApplication instance
      if(adOrNot === 'NOAD'){return}
      let redirectUri = '',postLogoutRedirectUri=''
      if(window.location.host.indexOf('qrcodeuat.kraftheinz.net.cn')!=-1){
        redirectUri = "https://qrcodeuat.kraftheinz.net.cn/index.html";//window.location.host + "/#/?ad=1";//defaults to application start page
        postLogoutRedirectUri = "https://qrcodeuat.kraftheinz.net.cn/index.html";//window.location.host;
      }else if(window.location.host.indexOf('qrcode.kraftheinz.net.cn')!=-1){
        clientId = "2f956185-93bf-4f7c-aec3-6b6699b5ccc7"
        redirectUri = "https://qrcode.kraftheinz.net.cn/";//window.location.host + "/#/?ad=1";//defaults to application start page
        postLogoutRedirectUri = "https://qrcode.kraftheinz.net.cn/";//window.location.host;
      }else {
        return this.$Message.error("当前不可登录AD账号");
      }
      const config = { auth: { clientId, redirectUri, postLogoutRedirectUri,tenantId,authority } }
      const loginRequest = { scopes: ["User.ReadWrite"] }

      const myMsal = new Msal.PublicClientApplication(config);
      
      myMsal.loginPopup(loginRequest)
          .then(function (loginResponse) {
            console.log(loginResponse,'loginResponse')
              const {accessToken,account} = loginResponse
              const {homeAccountId}=account
              localStorage.setItem('homeAccountId',homeAccountId)
              that.$cookies.set('accessToken', accessToken,'7d');
              that.$cookies.set('USERLANGUAGE', "CN",'7d');
              // //登录
              let entCode = process.env.NODE_ENV&&process.env.NODE_ENV=='development'?'heinz':'Heinz'
              that.axios.get(that.GLOBAL + `open/${entCode}/auth`,{}).then(res => {
                console.log(res,'res')
                if(res.data.code == 1000){//
                  if(res.data.data.result==1){
                    const {mode}=res.data.data
                    localStorage.removeItem("logoutload");
                    // 菜单临时在这写后期优化
                      that.$store.dispatch("getHomepageMenus", mode.userId);
                    //存住用户id
                    localStorage.setItem("thisUserId", mode.userId);
                    localStorage.setItem("userId", mode.userId);
                    localStorage.setItem('userName', mode.name);
                    localStorage.setItem('userNameNew', mode.userName);
                    // 存住企业code 
                      localStorage.setItem("eseCode", mode.eseCode);
                      localStorage.setItem("firstLogin", mode.firstLogin);
                    // 记住登录成功的地址
                    localStorage.setItem("hostUrl", window.location.href);
                    localStorage.setItem('hostName',window.location.href.substring(0,window.location.href.indexOf('?')))
                    // 设置面包屑的值
                    localStorage.setItem("breakFirst", "主页");
                    localStorage.setItem("breakTwo", "");
                      that.$store.commit(
                      "seteseCode",
                      localStorage.getItem("eseCode")
                    );
                    that.$store.commit('setUserName', mode.name)
                    
                    that.$store.commit(
                      "setbreakFirst",
                      localStorage.getItem("breakFirst")
                    );
                    that.$store.commit(
                      "setbreakTwo",
                      localStorage.getItem("breakTwo")
                    );
                    // 初始化站展开菜单
                      sessionStorage.setItem(
                      "openData",
                      JSON.stringify({ openName: '', activeName: '' })
                    );
                    return that.$router.push({
                      name: "main"
                    });
                  }
                }
              }).catch(err=>{
                console.log(err)
              });
          }).catch(function (error) {
              //login failure
              console.log(error,'error');
              alert("请刷新页面，重新操作")
              this.adOrNot = 'NOAD'
          });
    },
    goislogin(){
      const accessToken = this.$cookies.get('accessToken')//
      if(accessToken&&accessToken!==""&&accessToken!=null){
        this.adOrNot = 'AD'
        console.log(accessToken,'accessToken')
        let entCode = process.env.NODE_ENV&&process.env.NODE_ENV=='development'?'heinz':'Heinz'
        this.axios.get(this.GLOBAL + `open/${entCode}/auth`,{}).then(res => {
          console.log(res,'res')
          if(res.data.code == 1000){//
            if(res.data.data.result==1){
              const {mode}=res.data.data
              localStorage.removeItem("logoutload");
              // 菜单临时在这写后期优化
                this.$store.dispatch("getHomepageMenus", mode.userId);
              //存住用户id
              localStorage.setItem("userId", mode.userId);
              localStorage.setItem("thisUserId", mode.userId);
              localStorage.setItem('userName', mode.name);
              localStorage.setItem('userNameNew', mode.userName);
              // 存住企业code 
                localStorage.setItem("eseCode", mode.eseCode);
                localStorage.setItem("firstLogin", mode.firstLogin);
              // 记住登录成功的地址
              localStorage.setItem("hostUrl", window.location.href);
              localStorage.setItem('hostName',window.location.href.substring(0,window.location.href.indexOf('?')))
              // 设置面包屑的值
              localStorage.setItem("breakFirst", "主页");
              localStorage.setItem("breakTwo", "");
                this.$store.commit(
                "seteseCode",
                localStorage.getItem("eseCode")
              );
              that.$store.commit('setUserName', mode.name)
              this.$store.commit(
                "setbreakFirst",
                localStorage.getItem("breakFirst")
              );
              this.$store.commit(
                "setbreakTwo",
                localStorage.getItem("breakTwo")
              );
              // 初始化站展开菜单
                sessionStorage.setItem(
                "openData",
                JSON.stringify({ openName: '', activeName: '' })
              );
              
              return this.$router.push({
                name: "main"
              });
            }else{
              this.adOrNot = 'NOAD'
            }
          }
        }).catch(err=>{
          console.log(err)
        });
      }
      
    },

    // 时间格式化
    getyyyyMMdd() {
      var d = new Date();
      var curr_date = d.getDate();
      var curr_month = d.getMonth() + 1;
      var curr_year = d.getFullYear();
      String(curr_month).length < 2
        ? (curr_month = "0" + curr_month)
        : curr_month;
      String(curr_date).length < 2 ? (curr_date = "0" + curr_date) : curr_date;
      var yyyyMMdd = curr_year + "" + curr_month + "" + curr_date;
      return yyyyMMdd;
    },
    // 调用菜单接口
    getMenuData() {
      let data = {};
      data.userId = this.$store.state.user.userId;
      let hasdealData = [];
      let that = this;
      this.axios
        .post(this.GLOBAL + "api/auth/menu/list", data)
        .then(res => {
          console.log("sss",res)
          let resultData = res.data.data;
          if (res.data.code == 1000) {
            console.log(res)
            for (const role of resultData) {
              if (role.parentId == 0) {
                let fathermenu = JSON.parse(JSON.stringify(role));
                fathermenu.children = [];

                for (var childrens of resultData) {
                  if (childrens.parentId == role.id) {
                    let childmenu = JSON.parse(JSON.stringify(childrens));
                    fathermenu.children.push(childmenu);
                  }
                }
                hasdealData.push(fathermenu);
                
              }
            }
            localStorage.setItem("isShow",'true')
          }else{
            console.log(res,'10046',res.data.msg)
            this.$Message.error(res.data.msg);
            localStorage.setItem("isShow",'false')
          }
        });
       
    },
    handleSubmit() {
      let that = this;
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          // if (that.form.checkCode.toUpperCase() !== this.code) {
          //   this.$Message.info("验证码输入不正确");
          //   that.form.checkCode = ""; //新加验证码输入不正确时自动清空验证码框，优化客户体验
          //   this.$refs.imgVerify.draw();
          //   return false;
          // }
          console.log(that.form.checkCode);
          let data = {
            userName: (this.form.userName).trim(),
            password:(this.form.password).trim(),
            //  that.md5(
            //   that.md5(this.form.password) + this.getyyyyMMdd(new Date())
            // ), //md5(md5(密码)+yyyyMMdd)
            authCode:that.form.checkCode
          };
          
          this.$store.dispatch("handleLogin", data).then(res => {
            if (res.data.code == 1000) {
                // alert(JSON.stringify(res));
                localStorage.removeItem("logoutload");
              // 菜单临时在这写后期优化
                that.$store.dispatch("getHomepageMenus", res.data.data.userId);
              //存住用户id
              localStorage.setItem("userId", res.data.data.userId);
              localStorage.setItem("thisUserId", res.data.data.userId);
              localStorage.setItem('userName', res.data.data.name);
              localStorage.setItem('userNameNew',res.data.data.userName);
              // 存住企业code 
                localStorage.setItem("eseCode", res.data.data.eseCode);
                localStorage.setItem("firstLogin", res.data.data.firstLogin);
              // 记住登录成功的地址
               localStorage.setItem("hostUrl", window.location.href);
               localStorage.setItem('hostName',window.location.href.substring(0,window.location.href.indexOf('?')))
              // 设置面包屑的值
              localStorage.setItem("breakFirst", "主页");
              localStorage.setItem("breakTwo", "");
              that.$store.commit('setUserName', res.data.data.name)
                 this.$store.commit(
                 "seteseCode",
                 localStorage.getItem("eseCode")
              );
              
              this.$store.commit(
                "setbreakFirst",
                localStorage.getItem("breakFirst")
              );
              this.$store.commit(
                "setbreakTwo",
                localStorage.getItem("breakTwo")
              );
              // 初始化站展开菜单
                sessionStorage.setItem(
                "openData",
                JSON.stringify({ openName: '', activeName: '' })
              );
              this.$router.push({
                name: "main"
              });
            } else {
              this.$Message.error(res.data.msg);
            }
          });
        }
      });
    }
  },
  mounted(){
    this.getVscode()
    this.goislogin()
    
  }
};
</script>
<style lang="less">
.loadCenter {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 200px
}
.imgVscode{
  width:100px;
  margin-top:-4px;
}
.form-item-code{
    .ivu-form-item-content{
      display: flex;
      justify-content: space-between;
    }
  }
.demo-spin-icon-load{
        animation: ani-demo-spin 1s linear infinite;
    }
    @keyframes ani-demo-spin {
        from { transform: rotate(0deg);}
        50%  { transform: rotate(180deg);}
        to   { transform: rotate(360deg);}
    }
    .demo-spin-col{
        height: 100px;
        position: relative;
        border: 1px solid #eee;
    }
</style>



// WEBPACK FOOTER //
// src/view/login/login.vue